import { render, staticRenderFns } from "./AccountFollow.vue?vue&type=template&id=e4bfb496&"
import script from "./AccountFollow.vue?vue&type=script&lang=js&"
export * from "./AccountFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports